import * as echarts from "echarts";
import { getTheme} from '@/utils/auth'
require("echarts/extension/bmap/bmap");
import "echarts-gl";
import Vue from 'vue'
// enumerating ECharts events for now
const ACTION_EVENTS = [
  "legendselectchanged",
  "legendselected",
  "legendunselected",
  "datazoom",
  "datarangeselected",
  "timelinechanged",
  "timelineplaychanged",
  "restore",
  "dataviewchanged",
  "magictypechanged",
  "geoselectchanged",
  "geoselected",
  "geounselected",
  "pieselectchanged",
  "pieselected",
  "pieunselected",
  "mapselectchanged",
  "mapselected",
  "mapunselected",
  "axisareaselected",
  "brush",
  "brushselected",
];
const MOUSE_EVENTS = [
  "click",
  // "dblclick",  //单独绑定了
  "mouseover",
  "mouseout",
  "mousedown",
  "mouseup",
  "globalout",
];

/**
 * @el string dom节点的id require
 * @option object echarts的option require
 * @params object { 
 *  autoResize：{ //自适应
 *    type:boolean,
 *    default:true
 *  },
 *  saveAsImage：{  //保存图片
 *    type:boolean,
 *    default:true
 *  },
 *  miniScale:number  //图形最小缩放倍数
 *  eventKey：string //  事件key
 * }
 */

class echartsInit{
  constructor(el,option,{autoResize,saveAsImage,miniScale,eventKey}={}) {
    this.domEl =document.getElementById(el) 
    this.option = option;
    this.autoResize = autoResize == undefined?true:autoResize
    this.saveAsImage = saveAsImage== undefined?true:saveAsImage
    this.miniScale = miniScale
    this.eventKey = eventKey||"";
    this.$Bus = Vue.prototype.$Bus
    this.nowScale =  1
    this.defaultScale =  0.5

    this.echartInit()
    this.renderGlobalEvent()
  }
  
  echartInit(){
    let theme = getTheme();
    const ThemeInfo = Vue.prototype.$ThemeInfo
    let chart = echarts.getInstanceByDom(this.domEl) || null;
    const { option, miniScale } = this;
    if (chart) {
      this.setOption(option)
      return false;
    }
    echarts.registerTheme(theme, ThemeInfo[theme]);
    chart = echarts.init(this.domEl, theme);
    if (this.saveAsImage) {
      if (option.toolbox && option.toolbox != {}) {
        if (option.toolbox.feature && option.toolbox.feature != {}) {
          option.toolbox.feature.saveAsImage = ThemeInfo[theme].toolbox.saveAsImage;
        } else {
          option.toolbox.feature = {
            saveAsImage: ThemeInfo[theme].toolbox.saveAsImage
          }
        }
      } else {
        option.toolbox = {
          feature: {
            saveAsImage: ThemeInfo[theme].toolbox.saveAsImage
          }
        }
      }
    }
    chart.setOption(option);
    // console.log('end===', new Date().getTime());
    // 自定义点击事件回调
    ACTION_EVENTS.forEach((event) => {
      chart.on(event, (params) => {
        this.$Bus.$emit(event + this.eventKey, params);
      });
    });
    // 自定义鼠标事件回调
    MOUSE_EVENTS.forEach((event) => {
      chart.on(event, (params) => {
        this.$Bus.$emit(event + (this.eventKey || ''), params);
      });
    });

    if (miniScale) {
      this.controlScale(chart);
    }

    chart.getZr().on("dblclick", (params) => {
      this.$Bus.$emit('dblclick' + this.eventKey, params, chart);
    })
  }
  getOption(){
    let chart = echarts.getInstanceByDom(this.domEl) || null;
    return chart.getOption();
  }
  setOption(option,flag){
    let chart = echarts.getInstanceByDom(this.domEl) || null;
    chart.setOption(option,flag)
  }
  renderGlobalEvent(){
    if (this.autoResize) {
      window.addEventListener("resize", this._resizeHanlder.bind(this), false);
    }
    // 监听主题变化
    this.$Bus.$on("changeTheme", (theme) => {
      let chart = echarts.getInstanceByDom(this.domEl) || null;
      chart && chart.dispose();
      this.echartInit(theme);
    });
  }
  clear() {
    this._delegateMethod("clear");
  }
  dispose() {
    this._delegateMethod("dispose");
  }
  resize() {
    this._delegateMethod("resize");
  }
  _delegateMethod(name, ...args) {
    let chart = echarts.getInstanceByDom(this.domEl) || null;
    if (!chart) {
      return;
    }
    return chart[name](...args);
  }
  _resizeHanlder() {
    this.$Bus.$emit("resize");
    let chart = echarts.getInstanceByDom(this.domEl) || null;
    window.setTimeout(() => {
      chart && chart.resize();
    }, 100);
  }
  controlScale(chart) {
    let _this = this;
    /*
     * 树图缩放比例控制
     * */
    this.miniScale = this.miniScale || this.defaultScale;
    chart.on("treeRoam", (params) => {
      let zoom;
      if (params.zoom) {
        zoom = params.zoom;
        this.nowScale = parseFloat(zoom) * this.nowScale;

        if (this.nowScale < this.miniScale) {
          if (zoom < 1) {
            chart.setOption({
              series: [
                {
                  roam: "move",
                },
              ],
            });
          } else {
            chart.setOption({
              series: [
                {
                  roam: true,
                },
              ],
            });
          }
        }
      }
    });
    chart.getZr().on("mousewheel", wheel);
    //统一处理滚轮滚动事件
    function wheel(event) {
      var delta = 0;
      if (!event) event = window.event;
      if (event.wheelDelta) {
        //IE、chrome浏览器使用的是wheelDelta，并且值为“正负120”
        delta = event.wheelDelta / 120;
        if (window.opera) delta = -delta; //因为IE、chrome等向下滚动是负值，FF是正值，为了处理一致性，在此取反处理
      } else if (event.detail) {
        //FF浏览器使用的是detail,其值为“正负3”
        delta = -event.detail / 3;
      }
      if (delta) {
        if (_this.nowScale < _this.miniScale) {
          handle(delta);
        }
      }
    }
    //上下滚动时的具体处理函数
    function handle(delta) {
      if (delta < 0) {
        //向下滚动
        chart.setOption({
          series: [
            {
              roam: "move",
            },
          ],
        });
      } else {
        //向上滚动
        chart.setOption({
          series: [
            {
              roam: true,
            },
          ],
        });
      }
    }
  }
}

export default echartsInit